import { useCallback } from "react";

import { homeLoan } from "@/data/loans";
import { LOAN_TYPES } from "@/constants/loanTypes";

import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import PartnerBanks from "@/components/landing/PartnerBanks";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

export default function HomeLoan() {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...homeLoan.seo} />

      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...homeLoan.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />
        <LoanOverview {...homeLoan.overview} />
        <LoanBenefits {...homeLoan.benefits} />
        <LoanTypes {...homeLoan.types} />
        <LoanEligibility
          {...homeLoan.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />
        <LoanDocuments {...homeLoan.documents} />
        <LoanProcess {...homeLoan.process} />
        <WhyMoneyMart {...homeLoan.whyMoneyMart} />
        <PartnerBanks />
        <LoanFAQ {...homeLoan.faq} />
        <LoanCTA {...homeLoan.cta} onApply={scrollToLeadForm} />
        <LeadFormSection
          {...homeLoan.leadForm}
          loanType="HOME_LOAN"
        />
      </LoanLayout>
    </>
  );
}
